import { GoogleAnalyticsService } from '@grupoboticario/barril-del-chavo'

export interface SendEventErrorParams {
  type: string
  externalId?: string
  origin: string | null
  slug: string | null
}

export const sendEventToGA = ({ type, externalId, origin, slug = '' }: SendEventErrorParams) => {
  if (!type || !externalId || !origin) {
    return
  }
  const event = {
    event: 'event',
    eventCategory: 'redirect',
    eventAction: `redirect:${type}`,
    eventLabel: slug ? `${externalId}:${origin}:${slug}` : `${externalId}:${origin}`,
  }

  GoogleAnalyticsService.event(event)
}
